import { Component, OnInit, ViewChild, Inject, Input, OnDestroy } from '@angular/core';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from "@angular/router";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { SubSink} from "subsink";
import { take } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {
  @Input() id;
  public inventory: any;
  public dataSource: any;
  public count: number;
  public total: number;
  public countSubscription: Subscription;
  public displayedColumns = ['prdNameEn', 'invitmCount', 'prdRetail', 'total']
  public endTimeStamp: string = '';
  public isLoaded: boolean = false;
  public subTotal: number = 0;
  public tax1 = null;
  public tax2 = null;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public _loc: Location,
    public _activatedRoute: ActivatedRoute,
    private _router: Router,
    public _inventoryService: InventoryService,
    private _dialogRef: MatDialogRef<InvoiceComponent>
  ) { }

  ngOnInit(): void {
    this._inventoryService.onGetInvoice();
    this._inventoryService.invoice$.pipe(take(2)).subscribe(data => {
      this.inventory = data.inv
      this.total = data.total;
      this.endTimeStamp = data.endTimeStamp;
      this.dataSource = new MatTableDataSource(data.invItems);
      this.isLoaded = true;
      this.subTotal = data.subTotal;
      if(this.onCheckIfEmpty(data.tax1)){
        this.tax1 = data.tax1;
      }
      if(this.onCheckIfEmpty(data.tax2)){
        this.tax2 = data.tax2;
      }
    });
  }

  onCheckIfEmpty(obj){
    for(var prop in obj) {
      if(obj.hasOwnProperty(prop))
          return true;
    }

    return false;
  }

  onClose(){
    this._dialogRef.close();
  }

  generatePDF() {
    this._inventoryService.onGetInvoicePDF();
  }

  // onSortData(sort: Sort) {
  //   const data = this.dataSource.data.slice();
  //   if (!sort.active || sort.direction === '') {
  //     this.sortedData = data;
  //     return;
  //   }

  //   this.sortedData = data.sort((a, b) => {
  //     const isAsc = sort.direction === 'asc';
  //     switch (sort.active) {
  //       case 'totalCost': return this.compare((a.invitmCount * a.prdCost).toFixed(2), (b.invitmCount * b.prdCost).toFixed(2), isAsc);
  //       case 'totalRetail': return this.compare((0.00 + a.invitmCount * a.prdRetail).toFixed(2),
  //         (0.00 + b.invitmCount * b.prdRetail).toFixed(2), isAsc);
  //       case 'totalAvail': return this.compare((a.prdRetail - a.prdCost * a.invitmCount).toFixed(2),
  //         (b.prdRetail - b.prdCost * b.invitmCount).toFixed(2), isAsc);
  //       case 'prdCode': return this.compare(a.prdCode, b.prdCode, isAsc);
  //       case 'prdNameEn': return this.compare(a.prdNameEn, b.prdNameEn, isAsc);
  //       case 'invitmCount': return this.compare(a.invitmCount, b.invitmCount, isAsc);
  //       case 'prdPackageUOM': return this.compare(a.prdPackageUOM, b.prdPackageUOM, isAsc);
  //       case 'prdCost': return this.compare(a.prdCost, b.prdCost, isAsc);
  //       case 'prdRetail': return this.compare(a.prdRetail, b.prdRetail, isAsc)
  //       default: return 0;
  //     }
  //   });

  //   this.dataSource = this.sortedData;
  // }

  compare(a: any | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onNavigate(prdID){
    this._dialogRef.close();
    this._router.navigate([`/products/${prdID}`]);
  }
}
